module.exports = __webpack_public_path__ + "img/all-department-lllustration.576ad9cf.svg";